var _image;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "\\u7BAD\\u5934",
    width: 17,
    height: 13,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAANCAYAAABPeYUaAAAABHNCSVQICAgIfAhkiAAAAN1JREFUKFOFkgERwjAMRTsJWBgSQAKTwCSABCZhWEACkwASwAIWkAD/7VquzdqSu6xtkv3k/7ZxzrXyvV9fWi/yt7xk1G58cq5v9HlEQXIktgWgk+KjQe8B+WRanhUbTJyJabgy8QGQHDp1nfwe/XDTfmcAoL0GBLOULK1So16FUwChA52sQQuhczSYkmldAGGPYHS09lQg3EbIQQPxuYQEBMHoiID/DNGZcrZ4Es4lWjHoj0YJpEaLXEKjBlKjldCogZDjaV+NMAiMmAuzmsQFBx24LYSe5EdPZwHyBZt0K+vz3fdhAAAAAElFTkSuQmCC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArr);
export default __webpack_public_path__ + "static/media/arr.8ccec2d63d9fbb0863f13c77ab71e4ec.svg";
export { ForwardRef as ReactComponent };